import type { ApiNetwork, Network } from 'types/shared';

const initApiNetwork = (network: Network): ApiNetwork => {
  if (network === 'google') return 'ga';
  return '';
};

export default initApiNetwork;
